export default function isRoleReadOnly(roles) {
  return roles == "USER";
}